const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:8000/api';

const BUSINESSES = {
    BUSINESS_PROFILE: `${API_BASE_URL}/businesses/`,
    OWN_BUSINESS_PROFILE: `${API_BASE_URL}/businesses/me`,
    BUSINESS_CREATE: `${API_BASE_URL}/businesses/create/`,
    BUSINESS_ID: `${API_BASE_URL}/businesses/business-id/`,
    SUMMARY: `${API_BASE_URL}/businesses/summary/`,
    UPLOAD_PROFILE_IMAGE: `${API_BASE_URL}/businesses/upload-profile-image/`,
    UPLOAD_IMAGE: `${API_BASE_URL}/businesses/images/`,
    DELETE_IMAGE: (imageId) => `${API_BASE_URL}/businesses/images/delete/${imageId}/`,
    BUSINESS_IMAGES: (businessId) => `${API_BASE_URL}/businesses/business-images/${businessId}/`,
    BUSINESS_UPDATE: `${API_BASE_URL}/businesses/update/`,
};

export default BUSINESSES;